import Vue          from "vue";
import Vuex         from "vuex";
import VueRouter    from "vue-router";
import common       from './modules/common'
import user         from "./modules/user";
import layers       from "./modules/layers";
import projects     from "./modules/projects";
import documents    from "./modules/documents";
import share        from "./modules/share";
import axios        from "axios";

Vue.use(Vuex, axios, VueRouter);

export default new Vuex.Store({
    state:{},
    mutations: {},
    actions: {},
    getters: {},
    modules: {
        common,
        user,
        layers,
        projects,
        documents,
        share
    }
});
